import {
  Col,
  message,
  Row,
  Input,
  Spin,

} from "antd";
import {PlusOutlined,RollbackOutlined,InfoOutlined, DollarOutlined, ShopOutlined } from "@ant-design/icons"
import React, { useEffect, useState } from "react";
import { API } from "../../constant";
import { useNavigate  } from "react-router-dom";
import { useAuthContext } from "../../context/AuthContext";
import { getToken } from "../../helpers";
import { Button, Space } from "antd";
import { removeToken } from "../../helpers";



const Clientes = () => {
  const [Clients, setClients] = useState([]);
  const [filter, setFilter] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { user, setUser } = useAuthContext();
console.log('clients page')
const fetchClients = async () => {
  setIsLoading(true);
  try {
    const response = await fetch(`${API}/clientes?filters[agente][id]=${user?.id}&filters[activo][$eq]=true&populate=visitas`, {
      headers: {
        'Authorization': `Bearer ${getToken()}`,
      },
    });
    const data = await response.json();
    setClients(data.data ?? []);
  } catch (error) {
    console.error(error);
    message.error("Ha ocurrido un error");
  } finally {
    setIsLoading(false);
  }
};

  const navigate = useNavigate();

  useEffect(() => {
    if (!getToken()) {
      removeToken();
      navigate('/signin');
    }
  }, [navigate]);
  
  useEffect(() => {
    // Asegúrate de que `user` esté definido antes de llamar a `fetchClients`
    if (user !== undefined && user !== null) {
      fetchClients();
    }
  }, [user]);
  const handleSearchChange = (e) => {
    setFilter(e.target.value);
  };
  
  const handleNewVisitClick = (codigoCliente) => {
    navigate(`/newVisit/${codigoCliente}`);
  };
  const handleVisits = () => {
    navigate(`/visits/`);
  };
  const handleLastVisitClick = (codigoCliente) => {
    navigate(`/Lastvisit/${codigoCliente}`);
  };

  const filteredClients = Clients.filter((profile) =>
    profile.attributes.nombre.toLowerCase().includes(filter.toLowerCase()) ||
    profile.attributes.codigo.toLowerCase().includes(filter.toLowerCase()) ||
    profile.attributes.direccion?.toLowerCase().includes(filter.toLowerCase())
  );

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spin size="large" tip="Cargando..." />
      </div>
    );
  }

  return (
    <Row gutter={[32, 32]}
    style = {{flexDirection: 'row-reverse'}}
    >
    <div>
<Button
  onClick={() => window.location.href = 'https://partes.teambike.com/catalogo'}
  className="auth_button_signUp"
  type="secondary"
  style={{ marginRight: '20px' }}
>
  Catálogo digital
</Button>
    <Button
    onClick={handleVisits}
    className="auth_button_signUp"
    type="primary"
    style={{marginRight:'15px'}}
    >Mis visitas de hoy</Button>
    </div>
    <Col span={24}>
    <Input
      placeholder="Buscar por nombre"
      value={filter}
      onChange={handleSearchChange}
      style={{ marginBottom: 16 }}
    />
  </Col>
      <table className="table table-responsive-sm table-striped m-1">
        <thead>
          <tr>
            <th className="w-auto" scope="col">Cod</th>
            <th className="w-auto" scope="col" title="Clasificación Comercial"><ShopOutlined /></th>
            <th className="w-auto" scope="col" title="Clasificación Financiera"><DollarOutlined /></th>
            <th className="tablaClientes" scope="col">Nombre</th>
            <th className="w-auto" scope="col">Acciones</th>
          </tr>
        </thead>
        <tbody>
 
        {filteredClients.map((profile, index) => (
          <tr key={index}>
            <th scope="row">{profile.attributes.codigo}</th>
            <td>{profile.attributes.clasificacionComercial || '-'}</td>
            <td>{profile.attributes.clasificacionFinanciera || '-'}</td>
            <td className="tablaClientesRow">{profile.attributes.nombre}</td>
            <td>
              <button
                onClick={() => handleLastVisitClick(profile.id)}
                className="btn btn-sm btn-outline-secondary me-2"
              >
              <InfoOutlined  />
              </button>
              <button onClick={() => handleNewVisitClick(profile.id)} className="btn btn-sm btn-outline-danger">
                <PlusOutlined />
              </button>
            </td>
          </tr>
        ))}
      </tbody>
      </table>
    </Row>
  );
};

export default Clientes;